import * as R from 'ramda';
import { IDeveloperContact } from '../api/newbuildings';
import { IAppState } from '../common/state';

export function getIsLeadFactory(state: IAppState) {
  const contacts = R.pathOr<IDeveloperContact[]>([], ['results', 'newbuildingInfo', 'contacts'], state);

  return contacts.some(item => item.isLeadFactory);
}
